<template>
  <div ref="chart">
    <Chart :height="height" :id="id" :option="option"
           :width="width" :extendData="extendData"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "PowerBarChart",
  components: {Chart},
  props: {
    data: {
      type: Array,
      default: () => null
    },
    extendData: {
      type: Array,
      default: () => null
    },
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  data() {
    return {
      id: "PowerBarChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  mounted() {
    this.getOption();
  },
  methods: {
    getOption: function () {
      this.option = {
        // ---  提示框 ----
        tooltip: {
          trigger: 'item', // 数据项图形触发
          axisPointer: { // 指示样式
            type: 'shadow',
            axis: 'auto'
          },
          padding: 5,
          textStyle: { // 提示框内容的样式
            color: '#fff'
          }
        },
        //  ------  X轴 ------
        xAxis: {
          type: 'category', // 轴类型， 默认为 'category'
          axisLine: { // 坐标轴 轴线
            show: true, // 是否显示
            // ------   线 ---------
            lineStyle: {
              color: '#476E7B'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#FFFFFF',
              fontSize: '12'
            }
          },
          axisTick: { // 坐标轴 刻度
            show: false // 是否显示
          },
          data: ['在线', '离线', '正常', '告警'],
        },
        //   ------   y轴  ----------
        yAxis: {
          type: 'value',
          show: false
        },
        grid: {
          bottom: 0,
          containLabel: true
        },
        //  -------   内容数据 -------
        series: [
          {
            name: '', // 序列名称
            type: 'bar', // 类型
            legendHoverLink: true, // 是否启用图列 hover 时的联动高亮
            label: { // 图形上的文本标签
              show: true,
              position: 'top', // 相对位置
              rotate: 0, // 旋转角度
              color: '#eee'
            },
            itemStyle: { // 图形的形状
              color: '#4398ED',
              barBorderRadius: [18, 18, 0, 0]
            },
            barWidth: 30, // 柱形的宽度
            data: [
              {
                value: this.data[0],
                itemStyle: {
                  color: '#57BC00'
                }
              },
              {
                value: this.data[1],
                itemStyle: {
                  color: '#008BE2'
                }
              },
              {
                value: this.data[2],
                itemStyle: {
                  color: '#C4A32C'
                }
              }, {
                value: this.data[3],
                itemStyle: {
                  color: '#D06766'
                }
              },
            ],
          }
        ]
      }
    },
  },
}
</script>

<style scoped>

</style>
